// src/sections/AvisTrois.jsx
import React from "react";

const REVIEWS = [
  {
    name: "Martin C.",
    meta: "Il y a 4 jours, sur l’AppStore",
    text:
      "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Ut et massa mi. Aliquam in hendrerit urna. Pellentesque sit amet sapien fringilla, mattis ligula consectetur, ultrices mauris.",
    avatar: "https://pacte-claix.fr/assets/images/PPMCR%20V2.jpg",
  },
  {
    name: "Noe F.",
    meta: "Il y a 4 jours, sur l’AppStore",
    text:
      "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Ut et massa mi. Aliquam in hendrerit urna. Pellentesque sit amet sapien fringilla, mattis ligula consectetur, ultrices mauris.",
    avatar: "https://pacte-claix.fr/assets/images/PPNF.jpg",
  },
  {
    name: "Kinan F.",
    meta: "Il y a 4 jours, sur l’AppStore",
    text:
      "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Ut et massa mi. Aliquam in hendrerit urna. Pellentesque sit amet sapien fringilla, mattis ligula consectetur, ultrices mauris.",
    avatar: "https://pacte-claix.fr/assets/images/PPKF%20v2.jpg",
  },
];

function Card({ children }) {
  return (
    <div className="h-full rounded-[24px] bg-[#FAFAFA] shadow-[0_6px_18px_rgba(0,0,0,0.06)] p-5 sm:p-6">
      {children}
    </div>
  );
}

export default function AvisTrois() {
  return (
    <section className="mx-auto max-w-[1189px] px-4 sm:px-6 lg:px-8 py-16 sm:py-20">
      {/* Titre + sous-titre */}
      <div className="text-center max-w-4xl mx-auto">
        <h2 className="font-asap font-semibold tracking-tight text-neutral-900 text-[34px] sm:text-[46px] leading-[1.1]">
          Ils ont testé PACTE&nbsp;!
        </h2>
        <p className="mt-4 text-[15px] sm:text-[18px] text-neutral-600 leading-relaxed">
          Les utilisateurs Claixois vous partagent leurs expériences avec l'application PACTE : simplicité, consommation locale, fidélité et partage.

        </p>
      </div>

      {/* 3 cartes fixes + fades latéraux */}
      <div className="relative mt-10 sm:mt-12">
        {/* Grille */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 lg:gap-6">
          {REVIEWS.map((r, idx) => (
            <Card key={idx}>
              <div className="flex items-start gap-3">
                <img
                  src={r.avatar}
                  alt={r.name}
                  className="h-12 w-12 rounded-full object-cover shrink-0"
                />
                <div>
                  <div className="font-asap font-semibold text-neutral-900 text-[18px]">
                    {r.name}
                  </div>
                  <div className="text-xs text-neutral-500">{r.meta}</div>
                </div>
              </div>
              <p className="mt-4 text-[17px] leading-7 text-neutral-800">{r.text}</p>
            </Card>
          ))}
        </div>

        <div
          aria-hidden
          className="pointer-events-none absolute inset-y-0 -left-6 w-36 sm:w-16 bg-gradient-to-r from-white to-transparent"
        />
        <div
          aria-hidden
          className="pointer-events-none absolute inset-y-0 -right-6 w-36 sm:w-16 bg-gradient-to-l from-white to-transparent"
        />
      </div>
    </section>
  );
}